const routes = [
  {
    path: '/product',
    redirect: '/product/phone'
  },
  {
    path: '/product/index',
    redirect: '/product/phone'
  },
  {
    path: '/product/select',
    name: 'productSelect',
    meta: {
      type: 'page',
      title: '商品选择',
      stParams: {},
      is_done: 1
    },
    component: () => import(/* webpackChunkName: 'productselect' */ 'views/product/select')
  },
  {
    path: '/product/:category',
    name: 'productIndex',
    meta: {
      type: 'page',
      title: '类目',
      stParams: {},
      is_done: 1
    },
    component: () => import(/* webpackChunkName: 'productlist' */ 'views/product/index')
  },
  // 商品问答列表
  {
    path: '/product/qa/list',
    name: 'productQAList',
    meta: {
      type: 'page',
      title: '全部问答'
    },
    component: () => import(/* webpackChunkName: 'productQAList' */ 'views/product/qa/list')
  },
  // 商品问答详情
  {
    path: '/product/qa/detail',
    name: 'productQADetail',
    meta: {
      type: 'page',
      title: '问答详情'
    },
    component: () => import(/* webpackChunkName: 'productQADetail' */ 'views/product/qa/detail')
  },
  // 商品问答提交成功页
  {
    path: '/product/qa/success',
    name: 'productQASuccess',
    meta: {
      type: 'page',
      title: ' '
    },
    component: () => import(/* webpackChunkName: 'productQASuccess' */ 'views/product/qa/success')
  },
  {
    path: '/laser/confirm',
    name: 'laser',
    meta: {
      type: 'page',
      title: '添加定制信息',
      stParams: {},
      is_done: 1
    },
    component: () => import(/* webpackChunkName: 'laser' */ 'views/laser/index')
  },
  {
    path: '/integration/list/:id(\\d+)',
    name: '',
    meta: {
      type: 'page',
      title: '',
      stParams: {},
      is_done: 1
    },
    component: () => import(/* webpackChunkName: 'integrationlist' */ 'views/product/integration-list/index')
  },
  // 机型对比
  {
    path: '/compare',
    name: 'compare',
    meta: {
      type: 'page',
      title: '机型对比',
      is_done: 1
    },
    component: () => import(/* webpackChunkName: 'compare' */ 'views/compare/index')
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      type: 'page',
      title: '手机专区',
      stParams: {},
      is_done: 1
    },
    component: () => import(/* webpackChunkName: 'search' */ 'views/search/index')
  }
]

// 商详模板静态导入
import productDetail from 'views/product/detail/index/index.vue'

export default function (pageType = 1) {
  const productDetailRoute = {
    path: '/product/:spuId(\\d+)',
    name: 'productDetail',
    meta: {
      type: 'page',
      title: '商品详情',
      stParams: {},
      is_done: 1,
      lightDark: 1, // 深色模式的情况下是否自定义反色，0：删除meta自动反色，1：引入meta关闭自动反色
      showMenu: 'hide' // 是否显示常驻悬浮菜单
    },
    component:
      pageType === 3
        ? () => productDetail
        : () => import(/* webpackChunkName: 'product' */ 'views/product/detail/index/index.vue')
  }

  return [productDetailRoute, ...routes]
}
